import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ScanIcon, QrCodeIcon, ArrowRightIcon } from 'lucide-react';
import { BalanceCard } from '../components/BalanceCard';
import { TransactionList } from '../components/TransactionList';
import { walletData } from '../data/mockData';
export function WalletPage() {
  const navigate = useNavigate();
  const [showBalance, setShowBalance] = useState(true);
  return <div className="min-h-screen bg-gray-50 pb-20" data-id="element-293">
      <div className="max-w-lg mx-auto px-4 py-6 space-y-6" data-id="element-294">
        <header className="mb-2" data-id="element-295">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-296">Portefeuille</h1>
        </header>

        <BalanceCard balance={walletData.wallet.balance} currency={walletData.wallet.currency} showBalance={showBalance} onToggleVisibility={() => setShowBalance(!showBalance)} data-id="element-297" />

        <div className="grid grid-cols-2 gap-3" data-id="element-298">
          <button onClick={() => {
          /* TODO: Navigate to scanner */
        }} className="bg-white border-2 border-gray-200 rounded-xl p-4 hover:border-amber-500 hover:bg-amber-50 transition-all duration-200 flex flex-col items-center gap-2" data-id="element-299">
            <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center" data-id="element-300">
              <ScanIcon className="w-6 h-6 text-amber-600" data-id="element-301" />
            </div>
            <span className="font-semibold text-gray-900" data-id="element-302">Scanner</span>
            <span className="text-xs text-gray-500" data-id="element-303">Payer quelqu'un</span>
          </button>

          <button onClick={() => {
          /* TODO: Navigate to QR display */
        }} className="bg-white border-2 border-gray-200 rounded-xl p-4 hover:border-amber-500 hover:bg-amber-50 transition-all duration-200 flex flex-col items-center gap-2" data-id="element-304">
            <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center" data-id="element-305">
              <QrCodeIcon className="w-6 h-6 text-amber-600" data-id="element-306" />
            </div>
            <span className="font-semibold text-gray-900" data-id="element-307">Mon QR</span>
            <span className="text-xs text-gray-500" data-id="element-308">Recevoir paiement</span>
          </button>
        </div>

        <section data-id="element-309">
          <div className="flex items-center justify-between mb-4" data-id="element-310">
            <h2 className="text-lg font-bold text-gray-900" data-id="element-311">
              Transactions récentes
            </h2>
            <button className="text-sm text-amber-600 hover:text-amber-700 font-medium flex items-center gap-1" data-id="element-312">
              Voir tout
              <ArrowRightIcon className="w-4 h-4" data-id="element-313" />
            </button>
          </div>

          <TransactionList transactions={walletData.transactions} maxItems={5} data-id="element-314" />
        </section>
      </div>
    </div>;
}